/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Glad_Full_Duck_SpinInputs */

const en_glad_full_duck_spin = /** @type {(inputs: Glad_Full_Duck_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start import`)
};

const de_glad_full_duck_spin = /** @type {(inputs: Glad_Full_Duck_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import starten`)
};

/**
* | output |
* | --- |
* | "Start import" |
*
* @param {Glad_Full_Duck_SpinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const glad_full_duck_spin = /** @type {((inputs?: Glad_Full_Duck_SpinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Glad_Full_Duck_SpinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_glad_full_duck_spin(inputs)
	return de_glad_full_duck_spin(inputs)
});